module.exports = __webpack_public_path__ + "static/media/bowl-veggies1000.f95a9939.jpeg";